import { projectStatus } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { State } from "./types";

function replaceProject(
  state: State[number],
  { gantt }: Boundaries["retrieveProjectGantt"]["success"],
): State[number] {
  const indexes = gantt.projects.map((project) => ({
    project,
    index: state.gantt.projects.findIndex(({ uuid }) => uuid === project.uuid),
  }));

  return {
    ...state,
    gantt: {
      projects: indexes.reduce(
        (projects, { project, index }) =>
          index !== -1
            ? [
                ...projects.slice(0, index),
                { ...projects[index], ...project, shallow: false },
                ...projects.slice(index + 1),
              ]
            : [...projects, { ...project, shallow: false }],
        state.gantt.projects.map((p) => ({
          ...p,
          status: p.status ? p.status : { ...projectStatus, uuid: "" },
        })),
      ),
      constraints: [...state.gantt.constraints, ...gantt.constraints],
    },
  };
}

function handleRetrieveProjectGantt(
  state: State,
  data: Boundaries["retrieveProjectGantt"]["success"],
): State {
  return state.map((req) => replaceProject(req, data));
}

export { handleRetrieveProjectGantt };
